<template>
    <div class="lectures-wrapper">
        <crud-table :actions="actions" server-pagination :page-count="lectures.meta.last_page" :current-page="lectures.meta.current_page" :total="lectures.meta.total" :per-page="lectures.meta.per_page" title="المحاضرات" :items="lecturesItemsComputed" :headers="headers" @edit="openEditDialog" @load="loadMore" @create="createDialog =  true" @search="search" @delete="openDeleteDialog" @hide="openHideDialog" @unhide="openUnhideDialog" @reset="reset" v-sortable-data-table @sorted="saveOrder" :sort-icon="sortLectures">
            <template v-slot:header-actions>
                <div class="ms-2">
                    <v-btn color="purple" @click="sortLectures = !sortLectures" dark :outlined="sortLectures" depressed>
                        <v-icon left>mdi-sort</v-icon>
                        <span v-if="!sortLectures">تغيير الترتيب</span>
                        <span v-else>تم الترتيب</span>
                    </v-btn>
                </div>
            </template>
        </crud-table>

        <action-dialog v-model="createDialog" scrollable max-width="420" action="post" :url="`/lectures`" success-msg="تم إنشاء المحاضرة" title="محاضرة جديدة" subtitle="املأ بيانات المحاضرة الجديدة والفيديو" button-text="إنشاء" :data="{...newLectureFiltered, course_id: course_id}" @reset="resetCreateForm" @sync="addItem">
            <div class="pt-1">
                <v-text-field v-model="newLecture.name" label="اسم المحاضرة" hide-details class="mb-5" placeholder="أدخل اسم المحاضرة"></v-text-field>

                <template v-if="payLectures">
                    <v-text-field v-model="newLecture.price" type="number" label="سعر المحاضرة" placeholder="أدخل سعر المحاضرة" min="0"></v-text-field>
                    <v-text-field v-model="newLecture.expiry_days" type="number" label="أيام انتهاء الصلاحية (اختياري)" placeholder="تنتهي المحاضرة بعد ... يوم من شرائها" min="0"></v-text-field>
                </template>
                <template v-else>
                    <v-checkbox v-model="newLecture.preview" label="عرض المحاضرة كمعاينة" color="deep-purple accent-4" hint="سيتم السماح للمستخدم بالوصول لمحتوى المحاضرة كمعاينة للدورة بدون الحصول على الدورة" persistent-hint class="mb-3"></v-checkbox>
                </template>

                <v-checkbox v-model="addNewLectureVideo" label="إضافة فيديو للمحاضرة" color="primary" hide-details class="mb-3"></v-checkbox>

                <template v-if="addNewLectureVideo">
                    <v-text-field v-model="newLecture.video_name" label="عنوان الفيديو" placeholder="أدخل عنوان للفيديو"></v-text-field>
                    <v-select v-model="newLecture.video_type" label="نوع الفيديو" :items="videoTypesItems"></v-select>
                    <!-- <v-text-field v-if="newLecture.video_type === 'mp4'" v-model="newLecture.video_url" append-icon="mdi-link" label="رابط الفيديو" placeholder="أدخل رابط الفيديو"></v-text-field> -->
                    <v-text-field v-model="newLecture.video_url" append-icon="mdi-link" label="معرف الفيديو (ID)" :placeholder="'مثلاً: ' + (newLecture.video_type === 'vimeo' ? '406599043' : 'SyT3xUPz48E')" hint="معرف الفيديو (ID) هو رمز موجود في رابط الفيديو" persistent-hint></v-text-field>

                </template>
            </div>
        </action-dialog>

        <action-dialog v-model="editDialog" action="put" :url="`/lectures/${editedItem.id}`" max-width="400" success-msg="تم حفظ التغييرات بنجاح" title="تعديل المحاضرة" button-text="حفظ" :data="editedItemRequestData" @reset="resetEditForm" @sync="syncItem">
            <v-text-field v-model="editedItem.name" autofocus label="اسم المحاضرة" hide-details class="mb-5" placeholder="أدخل اسم المحاضرة"></v-text-field>
            <template v-if="payLectures">
                <v-text-field v-if="appData.teacher_can_control_lecture_price" v-model="editedItem.price" type="number" label="سعر المحاضرة *" placeholder="أدخل سعر المحاضرة" min="0"></v-text-field>
                <v-text-field v-model="editedItem.expiry_days" type="number" label="أيام انتهاء الصلاحية (اختياري)" placeholder="تنتهي المحاضرة بعد ... يوم من شرائها" min="0"></v-text-field>
            </template>
            <template v-else>
                <v-checkbox v-model="editedItem.preview" label="عرض المحاضرة كمعاينة" color="deep-purple accent-4" hint="سيتم السماح للمستخدم بالوصول لمحتوى المحاضرة كمعاينة للدورة بدون الحصول على الدورة" persistent-hint class="mb-3"></v-checkbox>
            </template>
        </action-dialog>

        <action-dialog v-if="appData.teacher_can_delete_lectures" v-model="deleteDialog" action="delete" :url="`/lectures/${deleteLecture ? deleteLecture.id : ''}`" title="حذف المحاضرة" button-text="تأكيد الحذف" button-color="error" @sync="deleteItem(deleteLecture.id)">
            <div v-if="deleteLecture">
                <div class="strong-text--text">
                    هل أنت متأكد من حذف المحاضرة <b class="strong-text--text">"{{deleteLecture.name}}"</b> ؟
                    <p class="muted--text mb-0 mt-2">
                        يمكنك إخفاء المحاضرة بدلاً من حذفها إذا كنت لا تريد الحذف النهائي.
                    </p>
                </div>
            </div>
        </action-dialog>

        <action-dialog v-model="hideDialog" action="put" :url="`/lectures/${hideLecture ? hideLecture.id : ''}`" :data="{is_hidden: true}" title="إخفاء المحاضرة" button-text="تأكيد اﻹخفاء" button-color="black" @sync="syncItem">
            <div v-if="hideLecture" class="strong-text--text">
                هل أنت متأكد من إخفاء المحاضرة <b class="strong-text--text">"{{hideLecture.name}}"</b> ؟
            </div>
        </action-dialog>

        <action-dialog v-model="unhideDialog" action="put" :url="`/lectures/${unhideLecture ? unhideLecture.id : ''}`" :data="{is_hidden: false}" title="إظهار المحاضرة" button-text="تأكيد اﻹظهار" button-color="primary" @sync="syncItem">
            <div v-if="unhideLecture" class="strong-text--text">
                هل أنت متأكد من إلغاء إخفاء المحاضرة <b class="strong-text--text">"{{unhideLecture.name}}"</b> ؟
            </div>
        </action-dialog>

    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import Sortable from 'sortablejs';

export default {
    components: {
        CrudTable,
    },
    props: {
        course: {},
        lectures: {},
        page_url: {},
        course_id: {},
        defaultPrice: {},
    },
    data() {
        return {
            editDialog: false,
            editedItem: {
                id: null,
                name: '',
                price: '',
                expiry_days: '',
                is_hidden: false,
                preview: false,
            },

            sortLectures: false,
            sortableInstance: null,

            createDialog: false,
            newLecture: {
                name: '',
                price: '',
                video_name: '',
                video_type: '',
                video_url: '',
                expiry_days: '',
                preview: false,
            },
            addNewLectureVideo: true,
            
            deleteDialog: false,
            deleteLecture: null,

            hideDialog: false,
            hideLecture: null,

            unhideDialog: false,
            unhideLecture: null,

            lecturesItems: null,
        }
    },
    computed: {
        lecturesItemsComputed(){
            return this.lecturesItems.map(lecture=>{
                return {
                    ...lecture,
                    lectureUrl: `/lectures/${lecture.id}`,
                    status: lecture.visibility,
                    notHidden: !lecture.is_hidden,
                    videoType: lecture.video ? lecture.video.type : null,
                    videoUrl: lecture.video ? lecture.video.video_url : '',
                    videoButtonText: 'فتح الفيديو',
                }
            });

        },
        headers(){
            let headers = [
                {
                    text: 'عمليات',
                    value: 'actions',
                    align: 'start',
                    sortable: false
                },
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'اسم المحاضرة',
                    align: 'center',
                    sortable: false,
                    value: 'name',
                    button: 'lectureUrl',
                    color: 'link'
                },
                {
                    text: 'سعر المحاضرة',
                    align: 'center',
                    sortable: false,
                    value: 'price',
                    price: true,
                    payLecturesOnly: true,
                },
                {
                    text: 'معاينة',
                    align: 'center',
                    sortable: false,
                    value: 'preview',
                    boolean: true,
                    payCoursesOnly: true,
                },
                {
                    text: 'أيام انتهاء الصلاحية',
                    align: 'center',
                    sortable: false,
                    value: 'expiry_days',
                    cellClass: 'error--text font-weight-bold',
                    payLecturesOnly: true,
                },
                {
                    text: 'عدد الفيديوهات',
                    align: 'center',
                    sortable: false,
                    value: 'videos_count',
                    number: true,
                    color: 'success'
                },
                {
                    text: 'الظهور',
                    value: 'status',
                    align: 'center',
                    sortable: false,
                },
                /* {
                    text: 'وقت اﻹنشاء',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                }, */
            ];
            return this.payLectures ? headers.filter(h=>!h.payCoursesOnly) : headers.filter(h=>!h.payLecturesOnly);
        },
        payLectures(){
            return this.course.pay_type === 'lectures';
        },
        actions(){
            let actions = [
                {name: 'hide', text: 'إخفاء المحاضرة', icon: 'mdi-eye-off', color: 'black', show: 'notHidden'},
                {name: 'unhide', text: 'إظهار المحاضرة', icon: 'mdi-eye', color: 'primary', show: 'is_hidden'},
                {name: 'edit', text: 'تعديل', icon: 'mdi-pencil'},
            ];
            if (this.appData.teacher_can_delete_lectures){
                actions.push({name: 'delete', text: 'حذف', icon: 'mdi-delete', color: 'error'});
            }
            return actions;
        },
        newLectureFiltered(){
            let data = {};
            const form = this.newLecture;
            for (let key in form){
                if (form[key]){
                    data[key] = form[key];
                }
            }
            return data;
        },
        videoTypesItems(){
            let types = [{text: 'Vimeo', value: 'vimeo'}];
            if (this.appData.enable_youtube_videos){
                types.push({text: 'Youtube', value: 'youtube'});
            }
            return types;
        },
        editedItemRequestData(){
            const editedItem = this.editedItem;
            let data = {
                name: editedItem.name,
                is_hidden: editedItem.is_hidden,
            };
            if (this.payLectures){
                data.price = editedItem.price;
                data.expiry_days = editedItem.expiry_days;
            }else{
                data.preview = editedItem.preview;
            }
            return data;
        },
        ...GlobalComputed,
    },
    watch: {
        lectures(lectures){
            this.lecturesItems = lectures.data;
        },
        sortLectures(sort){
            if (this.sortableInstance){
                this.sortableInstance.option('disabled', !sort);
            }
        }
    },
    methods: {
        ...GlobalMethods,
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        saveOrder(event) {
            const oldLectures = [...this.lecturesItems];
            // apply new order (localy)
            const movedItem = this.lecturesItems.splice(event.oldIndex, 1)[0];
            this.lecturesItems.splice(event.newIndex, 0, movedItem);

            // save new order (server)
            const lectures_order = this.lecturesItems.map((item, index)=>{
                return {id: item.id, order: index+1};
            });
            this.$store.dispatch('fastPostAction', {url: `/courses/${this.course.id}/lectures/order`, data: {order: lectures_order}}).then(()=>{
                // sort done
                this.showMsg('تم حفظ الترتيب الجديد', 'success', false, false, 1000)
            }).catch(e=>{
                this.showMsg('حدثت مشكلة أثناء ترتيب المحاضرات', 'error');
                // revert updates
                this.lecturesItems = oldLectures;
            })
        },
        addItem(item){
            this.lecturesItems.push(item);
        },
        resetCreateForm(){
            this.newLecture = {
                name: '',
                price: this.defaultPrice || '',
                expiry_days: '',
                video_name: '',
                video_type: '',
                video_url: '',
                preview: false,
            };
        },
        search(query){
            this.$inertia.visit(`${this.page_url}?query=${query}`);
        },
        reset(){
            this.$inertia.visit(this.page_url);
        },
        openEditDialog(lecture){
            Object.assign(this.editedItem, lecture);
            this.editDialog = true;
        },
        resetEditForm(){
             this.editedItem = {
                id: null,
                name: '',
                price: '',
                expiry_days: '',
                preview: false,
            };
        },
        syncItem(newItem){
            this.lecturesItems = this.lecturesItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.lecturesItems = this.lecturesItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openDeleteDialog(lecture){
            this.deleteDialog = true;
            this.deleteLecture = lecture;
        },
        openHideDialog(lecture){
            this.hideDialog = true;
            this.hideLecture = lecture;
        },
        openUnhideDialog(lecture){
            this.unhideDialog = true;
            this.unhideLecture = lecture;
        },

    },
    directives: {
        sortableDataTable: {
            bind (el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    },
                    disabled: !vnode.context.sortLectures,
                };
                // set this.sortableInstance to Sortable Object so we can update it's options later
                vnode.context.sortableInstance = Sortable.create(el.getElementsByTagName('tbody')[0], options)
            }
        }
    },
    created(){
        this.lecturesItems = this.lectures.data;
        this.newLecture.price = this.defaultPrice;
    },
    mounted(){
        
    }
}

</script>
